import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import OverviewDeviceCard from './OverviewDeviceCard.vue';
import OverviewDeviceCardStateKpi from './OverviewDeviceCardStateKpi.vue';
import { Device } from '@/models/device';
import { LaserTubeDeviceStateData } from '@/models/deviceStateData';
import { getStateCss } from '@/utils/color';
import { isNil } from '@/utils/misc';
import { abbreviateNumber, abbreviateNumberWithUnit } from '@/utils/number';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OverviewBendDeviceCard',
  props: {
    device: null,
    deviceState: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  device: Device;
  /**
   * Object containing the information about state and metrics of the device.
   * Can be undefined if there is no data for the device.
   */
  deviceState: LaserTubeDeviceStateData | undefined; // This old card still uses the old SP and thus its model/schema
};





const { t } = useI18n();

const hasState = computed(() => !isNil(props.deviceState?.lastState));

const stateStyle = computed(() => getStateCss(props.deviceState!.lastState!));

return { __sfc: true,props, emit, t, hasState, stateStyle, OverviewDeviceCard, OverviewDeviceCardStateKpi, abbreviateNumber, abbreviateNumberWithUnit }
}

})